module.exports = __webpack_public_path__ + "static/dia-8afcafba88643ad46923bb2cc2ea38c5.png";